<script>
    import PrestacionService from '@/api/PrestacionService';
    const prestacionService = new PrestacionService();

    export default {
        name: 'DiagnosticoOptions',
        props: {
            obligatorio: {
                type: Array,  
                required: true
            },
            diagnostico: {
                type: Object, 
                required: true
            }
        },
        data: () => ({
            diagnosticos: [],
            diagnosticosEnSelect: [],
            cargandoDiagnosticos: false,
        }),
        async mounted() {
            this.diagnosticos = await this.cargarDiagnosticos('');
            this.diagnosticosEnSelect = this.diagnosticos.slice();
        },
        methods: {
            itemTitleDiagnostico(item) {
                if (!item) return '';
                return `${item.codigo} - ${item.descripcion}`;
            },
            onDiagnosticoChange(newValue) {
                this.itemTitleDiagnostico(newValue);
                this.$emit('update:diagnostico', newValue);
            },
            selectItem(item) {
                this.$emit('update:modelValue', item.id);
                this.$refs.autocomplete.blur();
            },
            async cargarDiagnosticos(text){
                let diagnosticos = [];
                this.cargandoDiagnosticos = true;
                const response = await prestacionService.getDiagnosticos(text);
                if(response.status == 200){
                    diagnosticos = response.data;
                }
                this.cargandoDiagnosticos = false;
                return diagnosticos.slice();
            },
            async onSearchTextChange(){
                const searchText = this.$refs.autocomplete.search;
                this.diagnosticosEnSelect = [];
                if(searchText.length == 0){
                    this.diagnosticosEnSelect = this.diagnosticos.slice();
                }else {
                    if(searchText.length >= 3){
                        this.diagnosticosEnSelect = await this.cargarDiagnosticos(searchText);
                    }
                }
            }
        }
    }
</script>

<style src="../assets/general.css"></style>

<template>
    <label class="my-text-black">Ingrese al menos 3 caracteres para buscar.</label>
    <v-autocomplete
        :rules="obligatorio"
        label="Código - Descripción"
        :items="diagnosticosEnSelect"
        item-value="id"
        :item-title="itemTitleDiagnostico"
        variant="solo"
        @update:modelValue="onDiagnosticoChange"
        @input="onSearchTextChange"
        auto-select-first="true"
        no-data-text="No se encontraron resultados"
        :menu-props="{width: 250}"
        min-width="250"
        ref="autocomplete"
        class="asterisco"
        :loading="cargandoDiagnosticos"
    >
        <template #item="{ item, props }">
            <v-tooltip>
            <template v-slot:activator="{ on }">
            <div
                v-bind="props"
                v-on="on"
                class="autocomplete-item"
                @click="selectItem(item.raw)"
            >
                {{ item.raw.codigo }} - {{ item.raw.descripcion }}
            </div>
            </template>
            <span>{{ item.raw.descripcion }}</span>
            </v-tooltip>
        </template>
    </v-autocomplete>


</template>